export const UPDATE = 'app/UPDATE';
export const SET_SLUG = 'app/SET_SLUG';
export const SET_ROLE = 'app/SET_ROLE';
export const UPDATE_ROLE = 'app/UPDATE_ROLE';
export const SET_ACTIVE_MODULE = 'app/SET_ACTIVE_MODULE';
export const ADD_NOTIFICATION = 'app/ADD_NOTIFICATION';
export const REMOVE_NOTIFICATIONS = 'app/REMOVE_NOTIFICATIONS';
